import { cn } from "@/app/utils/cn";
import { Search } from "lucide-react";
import { Input, InputProps } from "./ui/input";

interface SearchInputProps extends InputProps {}

export const SearchInput = ({ className, ...props }: SearchInputProps) => {
  return (
    <div className="relative flex items-center">
      <Search size={20} className="z-2 absolute left-4 top-3" />
      <Input
        className={cn("ml-1 w-96 rounded-3xl pl-10", className)}
        placeholder="Pesquisar"
        {...props}
      />
    </div>
  );
};
